module.exports = __webpack_public_path__ + "img/rec-11.7de9a977.jpg";